import React from 'react';
import { Link } from 'react-router-dom';
import { HELP_TABS } from '../../../data/help';
import { formatHelpDate } from './helpFormat';

const BackIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

/** 업데이트·공지사항·뉴스룸 상세가 함께 쓰는 틀 (위치 표시, 날짜, 제목, 목록으로) */
const HelpArticle = ({ tab, backTo, date, title, badges = null, children, after = null }) => {
  const tabLabel = HELP_TABS.find(item => item.id === tab)?.label || '';
  return (
    <div className="help-article">
      <nav className="help-article__breadcrumb" aria-label="현재 위치">
        <Link to={backTo}>고객센터</Link>
        <span aria-hidden="true">/</span>
        <span>{tabLabel}</span>
      </nav>

      <article className="help-article__body">
        <header className="help-article__header">
          {date && <time className="help-article__date" dateTime={date}>{formatHelpDate(date)}</time>}
          <h1 className="help-article__title">{title}</h1>
          {badges}
        </header>
        {children}
      </article>

      {after}

      <div className="help-article__footer">
        <Link to={backTo} className="help-article__back">
          <BackIcon />
          목록으로
        </Link>
      </div>
    </div>
  );
};

export const HelpArticleNotFound = ({ backTo }) => (
  <div className="help-article help-article--missing">
    <p className="help-article__missing-title">글을 찾을 수 없어요</p>
    <p className="help-article__missing-desc">주소가 바뀌었거나 내려간 글이에요.</p>
    <Link to={backTo} className="help-article__back">
      <BackIcon />
      목록으로
    </Link>
  </div>
);

export default HelpArticle;
